/* eslint-disable */
/* this file is generated by generateIcons script */

import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class SoftwareUpdateIcon extends BaseIcon {
    getChildren = () => [<path
        d="M8.009,14v2L4.065,12.967,8.009,10v1.966a3.974,3.974,0,0,0,3.315-6.145L12.858,4.5A5.981,5.981,0,0,1,8.009,14ZM7.992,4H7.984A3.975,3.975,0,0,0,4.64,10.138l-1.55,1.3A5.988,5.988,0,0,1,7.992,2v-2l3.844,3.028L7.992,6V4Z"
        fill={this.getColor()} />]
    getViewBox = () => '0 0 16 16'
}